import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import language from '../../../assets/languages/language';
import { _getProfile } from '../../../common/function';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
/* eslint-disable*/

class Cfa3flashquestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRMATION_BOX}`,
      items_val: '',
      item_status: '',
      flashreport: [], //All Flash question Store
      token: '',
      idname: '',
      ValidToken: false,
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
    this.toggleDone = this.toggleDone.bind(this);
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to toggle alert box
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  //Function to delete flash card
  toggleAlert(card) {
    this.setState({
      alert_status: !this.state.alert_status,
      item_status: card,
    });
  }

  //Function to close toggle and set items status blank
  toggleClose() {
    this.setState({
      alert_status: !this.state.alert_status,
      items_val: '',
      item_status: '',
    });
  }

  //On Click ok button from alert perform deletion of cfa flash card
  toggleDone() {
    if (this.state.item_status === 'flashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      FD.callAPI(App_data.backend_api + '/cfa_3question_bank/deleteFlashCard', data).then(resp => {
        if (resp.success) {
          document.getElementById('flash_' + this.state.items_val.id).remove();
        } else {
          console.log('error');
        }
      });
    }
    this.setState({
      alert_status: false,
    });
  }

  //On click delete button ,set item value and open toggle alert
  _deleteFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('flashcard');
  };

  //Function to redirect, page to Dashboard page
  _getDashboard = () => {
    this.context.router.push({
      pathname: '/cfa3_dashboard/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  //On Page Load ,init this method
  componentDidMount() {
    window.scroll(0, 0);
    this.props.location.state
      ? this.setState({ username: this.props.location.state.username })
      : null;
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getFlashcardsbyuserid', data).then(
      resp => {
        if (resp.success) {
          this.setState({ flashreport: resp.flash_report });
        } else {
          console.log(resp.success + '------------failure');
        }
      },
    );
  }

  //Function to redirect page to particular question id
  _beginChapter = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.question_id,
    };
    FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getQuestionsbyid', data).then(resp => {
      if (resp.success) {
        var dataparam = {
          token: this.state.token,
          idname: this.state.idname,
          caseid: resp.questionsbyid.case_id,
        };
        FD.callAPI(App_data.backend_api + '/cfa_3question_bank/getCasesbyId', dataparam).then(
          resp_case => {
            if (resp_case.success) {
              this.context.router.push({
                pathname:
                  '/cfa3/chapter/' +
                  resp.questionsbyid.chapter_id +
                  '/' +
                  resp.questionsbyid.case_id +
                  '/' +
                  (parseInt(resp_case.casesingleData.case_number) - 1, 10) +
                  '/' +
                  resp.questionsbyid.question_number,
                state: { token: this.state.token, idname: this.state.idname },
              });
            } else {
              console.log('Some Thing Went Wrong');
            }
          },
        );
      } else {
        console.log('Not Found');
      }
    });
  };

  render() {
    let flashreport_val = this.state.flashreport;
    let flashcard_data = '';
    if (this.state.flashreport.length) {
      flashcard_data = flashreport_val.map((items, index) => (
        <div id={'flash_' + items.id} key={index} className=''>
          <div className='flash_box'>
            <div className='row align-items-center'>
              <div className='col-sm-8'>
                <span className='text_light margin_bottom_0'>
                  <strong> {language.LC().QUESTION_ID}</strong>: {items.question_id}
                </span>
                <span className='margin_left_15 text_light margin_bottom_0'>
                  <strong>{language.LC().Saved_Note}: </strong> {items.flash_card}
                </span>
              </div>
              <div className='col-sm-4 text-right xl-text-left'>
                <span className='up tooltip-hover-questions' style={{ padding: '10px' }}>
                  <div className='tootip_box'> {language.LC().VIEW} </div>
                  <i
                    onClick={this._beginChapter.bind(this, items)}
                    className={this.state.viewCSS}
                    style={{ color: '#1f8ceb' }}
                  >
                    {' '}
                  </i>
                </span>
                <span className='up tooltip-hover-questions' style={{ padding: '10px' }}>
                  <div className='tootip_box'> {language.LC().DELETE} </div>
                  <i
                    onClick={this._deleteFlashcard.bind(this, items)}
                    className={this.state.deleteCSS}
                    style={{ color: '#f51a00' }}
                  >
                    {' '}
                  </i>
                </span>
                {/* <button className="btn_circle_sm" onClick={this._beginChapter.bind(this,items)}><i className="fa fa-eye"></i></button>        
                        <button className="btn_circle_sm" onClick={this._deleteFlashcard.bind(this,items)}><i className="fa fa-trash"></i></button>           */}
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      flashcard_data = (
        <div className='horizontal_mid card-block text-center text_light'>
          {' '}
          {language.LC().NO_SAVED_FLASHCARDS}{' '}
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='card height_70vh'>
          <div className='card-header'>
            <div className='mb-1 d-inline-block'>
              {language.LC().MY_FLASHCARDS}{' '}
              <span className='text_light margin_left_15'>
                {' '}
                {language.LC().PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW}:{' '}
              </span>
            </div>
            <div className='card-actions float-md-right'>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getDashboard.bind(this)}
              >
                {language.LC().DASHBOARD}
              </button>
              <button
                type='button'
                className='btn btn-primary pointer_class margin_left_15'
                onClick={_getProfile.bind(this, this.state.username)}
              >
                {language.LC().PROFILE}
              </button>
            </div>
          </div>

          {flashcard_data}
        </div>

        <Modal
          isOpen={this.state.alert_status}
          toggle={this.toggleAlert}
          className={'modal-primary ' + this.props.className}
        >
          {/*<ModalHeader toggle={this.toggleClose}>{this.state.MessageTitle}</ModalHeader>*/}
          <ModalHeader>
            {language.LC().ALERT}
            <Button className='close' onClick={this.toggleClose}>
              ×
            </Button>
          </ModalHeader>
          <ModalBody>
            <div className='text-center'>
              <p className='margin_bottom_20'>
                <strong>{this.state.MessageContent}</strong>
              </p>
              <Button className='btn btn-primary' onClick={this.toggleDone}>
                {language.LC().OK}
              </Button>
            </div>
          </ModalBody>
          {/*<ModalFooter>
                </ModalFooter>*/}
        </Modal>
      </div>
    );
  }
}

export default Cfa3flashquestion;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3flashquestion/Cfa3flashquestion.js